import { Pipe, PipeTransform } from '@angular/core';
import { KeyValue } from '@approot/models';

@Pipe({
  name: 'arrayAttributeMap'
})
export class ArrayAttributeMapPipe implements PipeTransform {
  transform(value: KeyValue[], key: string): any[] {
    return value.map(x => x[key]);
  }
}
